var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFurniture1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.172,
    height: 53.718,
    viewBox: "0 0 48.172 53.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7742",
    "data-name": "Grupo 7742",
    transform: "translate(-53.848 -45.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_23",
    "data-name": "Uni\\xE3o 23",
    d: "M4.057,53.417a1,1,0,0,1-.994-1V43.747H1.582A1.585,1.585,0,0,1,0,42.165V31.3a1.583,1.583,0,0,1,1.582-1.582H6.288V18.055C6.288,8.457,13.9.363,23.263.012A17.664,17.664,0,0,1,41.584,17.646V29.715h4.7A1.583,1.583,0,0,1,47.872,31.3V42.165a1.584,1.584,0,0,1-1.583,1.582H44.81v8.669a1,1,0,0,1-1,1h-3.63a1,1,0,0,1-1-1V43.747H8.688v8.674a.994.994,0,0,1-.995,1Zm1-1.99H6.7V43.749H5.053Zm36.127-.006h1.641V43.751H41.18ZM24.935,41.757H45.883V35.831H24.935Zm-22.944,0H22.946V35.831H1.991Zm0-7.915H45.883V31.7h-8.59a.992.992,0,0,1-.243.036H10.821a.016.016,0,0,0-.009,0h-.05a.018.018,0,0,0-.01,0,.1.1,0,0,1-.024,0H10.7a.9.9,0,0,1-.123-.026H1.991Zm37.6-4.127V17.646A15.677,15.677,0,0,0,23.337,2c-8.3.311-15.058,7.513-15.058,16.054v11.66H9.847V17.646a14.1,14.1,0,0,1,14.8-14.068,14.27,14.27,0,0,1,13.378,14.45V29.715ZM11.837,17.646V29.713h24.2V18.028A12.282,12.282,0,0,0,24.55,5.567a12.109,12.109,0,0,0-12.713,12.08ZM23.31,1.007H23.3Zm9.436,38.785a.995.995,0,1,1,0-1.99h5.883a.995.995,0,0,1,0,1.99Zm-23.261,0a.995.995,0,1,1,0-1.99h5.882a.995.995,0,1,1,0,1.99Zm7.847-13.358a1,1,0,0,1,0-1.405l9.387-9.388a1,1,0,1,1,1.408,1.407l-9.387,9.387a1,1,0,0,1-1.408,0Zm0-6.668a1,1,0,0,1,0-1.407L26.719,8.97a1,1,0,1,1,1.408,1.407l-9.387,9.389a1,1,0,0,1-1.408,0Z",
    transform: "translate(53.998 45.81)",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2101",
    "data-name": "Ret\\xE2ngulo 2101",
    width: 46,
    height: 4,
    rx: 2,
    transform: "translate(55 77)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurniture1);
export default __webpack_public_path__ + "static/media/furniture-1.6072460a63c1127a209b30846f292db8.svg";
export { ForwardRef as ReactComponent };